import { render, staticRenderFns } from "./profesDetails.vue?vue&type=template&id=5486f542&scoped=true"
import script from "./profesDetails.vue?vue&type=script&lang=js"
export * from "./profesDetails.vue?vue&type=script&lang=js"
import style0 from "./profesDetails.vue?vue&type=style&index=0&id=5486f542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486f542",
  null
  
)

export default component.exports